module.exports = __webpack_public_path__ + "static/media/roodram.43abe841.jpg";